import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFoodBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFoodBell"><Path d="M13 4H11V5.04938C5.94668 5.5511 2 9.81465 2 15V16H22V15C22 9.81465 18.0533 5.5511 13 5.04938V4Z" fill="currentColor"/><Path d="M2 17V19H9V20H15V19H22V17H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFoodBell;
